import { render, staticRenderFns } from "./UserOfficerDetail.vue?vue&type=template&id=83e466f6&scoped=true&"
import script from "./UserOfficerDetail.vue?vue&type=script&lang=js&"
export * from "./UserOfficerDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserOfficerDetail.vue?vue&type=style&index=0&id=83e466f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e466f6",
  null
  
)

export default component.exports